// import Navbar from "./Navbar";

function Header(){
  return(
    <div id="brand-name">
      <h1>Asta Remeikiene</h1>


    </div>
  )
}

export default Header;


